module.exports = __webpack_public_path__ + "static/logo-ad670d49c39343955001d9c25f72be95.png";